<template>
    <div class="unsaved-modal-overlay">
        <div class="unsaved-modal">
            <div class = "unsaved-modal-title">
                <p>Unsaved changes will be lost. Would you like to save before leaving?</p>
            </div>
            <div class="unsaved-modal-buttons">
                <div class="unsaved-modal-left-buttons">
                    <button class="submenu-button submenu-button-negative" @click="$emit('cancel')">Cancel</button>
                </div>
                <div class="unsaved-modal-right-buttons gap-md">
                    <button class="submenu-button submenu-button-negative" @click="$emit('no')">No</button>
                    <button class="submenu-button submenu-button-affirmative" @click="$emit('yes')">Yes</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "UnsavedChangesModal",
    emits: ["yes", "no", "cancel"],
};
</script>

<style scoped>
.unsaved-modal-overlay {
    position: fixed;
    inset: 0;
    background: var(--colour-overlay-darken);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 2000;
}

.unsaved-modal {
    display: flex;
    flex-direction: column;
    background-color: var(--color-background);
    padding: var(--spacing-lg);
    border-radius: var(--radius-md);
    box-shadow: 0 0.25rem 0.75rem var(--color-border);
    max-width: 90%;
    text-align: center;
}

.unsaved-modal p {
    margin-bottom: var(--spacing-lg);
    font-size: var(--font-size-md);
    min-width: 0;
    overflow-wrap: break-word;
    font-weight: 600;
}

.unsaved-modal-buttons {
    display: flex;
    gap: var(--spacing-md);
}

.unsaved-modal-left-buttons {
    display: flex;
    justify-content: flex-start;
    flex-grow: 1;
}

.unsaved-modal-right-buttons {
    display: flex;
    justify-content: flex-end;
}
</style>
